import logo from './logo.svg';
// import './App.css';
import FormContainer from './applyform/FormContainer';

function App() {
  return (
    <div className="App">
        <FormContainer
            SwitchDataLink="/applyform/GetSwitchJSONData/"
            BuildCVApplyDataLink="/applyform/GetBuildCVApplyFormJSONData/"
            OwnCVApplyDataLink="/applyform/GetOwnCVApplyFormJSONData/"
            FastCVApplyFormJSONData="/applyform/GetFastCVApplyFormJSONData/"
            SendApplyLink="/applyform/sendApplication"
            handleCVForm="/applyform/handleBuildCVForm"
            trackInputLink="/bernd/input"
            trackSubmitLink="/bernd/submit"
        />
    </div>
  );
}

export default App;
